/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ trial_day: NonNullable<unknown>, yearly_price: NonNullable<unknown>, view_all_plans: NonNullable<unknown> }} Free_Trial_Cta_FooterInputs */

const en_free_trial_cta_footer = /** @type {(inputs: Free_Trial_Cta_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Free for the first ${i?.trial_day} days, then ${i?.yearly_price}/year. Cancel anytime. ${i?.view_all_plans}`)
};

const ar_free_trial_cta_footer = /** @type {(inputs: Free_Trial_Cta_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`مجاني لأول ${i?.trial_day} يومًا، ثم ${i?.yearly_price}/سنة. يمكنك الإلغاء في أي وقت. ${i?.view_all_plans}`)
};

const de_free_trial_cta_footer = /** @type {(inputs: Free_Trial_Cta_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`In den ersten ${i?.trial_day} Tagen kostenlos, danach ${i?.yearly_price}/Jahr. Jederzeit kündbar. ${i?.view_all_plans}`)
};

const es_free_trial_cta_footer = /** @type {(inputs: Free_Trial_Cta_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gratis por los primeros ${i?.trial_day} días, después ${i?.yearly_price} / año. Cancela en cualquier momento. ${i?.view_all_plans}`)
};

const fr_free_trial_cta_footer = /** @type {(inputs: Free_Trial_Cta_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gratuit pendant les ${i?.trial_day} premiers jours, puis ${i?.yearly_price}/an. Résiliable à tout moment. ${i?.view_all_plans}`)
};

const it_free_trial_cta_footer = /** @type {(inputs: Free_Trial_Cta_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gratuito per i primi ${i?.trial_day} giorni, poi ${i?.yearly_price} all'anno. Annulla in qualsiasi momento. ${i?.view_all_plans}`)
};

const ja_free_trial_cta_footer = /** @type {(inputs: Free_Trial_Cta_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最初の${i?.trial_day}日間は無料、その後は${i?.yearly_price}/年、いつでもキャンセル可能。${i?.view_all_plans}`)
};

const ko_free_trial_cta_footer = /** @type {(inputs: Free_Trial_Cta_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`첫 ${i?.trial_day}일 무료, 이후 년간 ${i?.yearly_price}. 언제든지 취소 가능. ${i?.view_all_plans}`)
};

const pt_br_free_trial_cta_footer = /** @type {(inputs: Free_Trial_Cta_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Grátis pelos primeiros ${i?.trial_day} dias, então ${i?.yearly_price}/ano. Cancele quando quiser. ${i?.view_all_plans}`)
};

const ru_free_trial_cta_footer = /** @type {(inputs: Free_Trial_Cta_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Бесплатно первые ${i?.trial_day} дней, затем ${i?.yearly_price}/год. Отмена в любое время. ${i?.view_all_plans}`)
};

const th_free_trial_cta_footer = /** @type {(inputs: Free_Trial_Cta_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ทดลองใช้ฟรี ${i?.trial_day} วันแรก จากนั้น ${i?.yearly_price}/ปี ยกเลิกได้ทุกเมื่อ ${i?.view_all_plans}`)
};

const tr_free_trial_cta_footer = /** @type {(inputs: Free_Trial_Cta_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`İlk ${i?.trial_day} boyunca ücretsiz, ardından yılda ${i?.yearly_price}. İstediğin zaman iptal edebilirsin. ${i?.view_all_plans}`)
};

const zh_cn_free_trial_cta_footer = /** @type {(inputs: Free_Trial_Cta_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`前 ${i?.trial_day} 天免费, 之后 ${i?.yearly_price}/年，随时可取消。 ${i?.view_all_plans}`)
};

const zh_tw_free_trial_cta_footer = /** @type {(inputs: Free_Trial_Cta_FooterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`前 ${i?.trial_day} 天免費, 之後 ${i?.yearly_price}/年，隨時可取消。 ${i?.view_all_plans}`)
};

/**
* | output |
* | --- |
* | "Free for the first {trial_day} days, then {yearly_price}/year. Cancel anytime. {view_all_plans}" |
*
* @param {Free_Trial_Cta_FooterInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const free_trial_cta_footer = /** @type {((inputs: Free_Trial_Cta_FooterInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Free_Trial_Cta_FooterInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_free_trial_cta_footer(inputs)
	if (locale === "ar") return ar_free_trial_cta_footer(inputs)
	if (locale === "de") return de_free_trial_cta_footer(inputs)
	if (locale === "es") return es_free_trial_cta_footer(inputs)
	if (locale === "fr") return fr_free_trial_cta_footer(inputs)
	if (locale === "it") return it_free_trial_cta_footer(inputs)
	if (locale === "ja") return ja_free_trial_cta_footer(inputs)
	if (locale === "ko") return ko_free_trial_cta_footer(inputs)
	if (locale === "pt_br") return pt_br_free_trial_cta_footer(inputs)
	if (locale === "ru") return ru_free_trial_cta_footer(inputs)
	if (locale === "th") return th_free_trial_cta_footer(inputs)
	if (locale === "tr") return tr_free_trial_cta_footer(inputs)
	if (locale === "zh_cn") return zh_cn_free_trial_cta_footer(inputs)
	return zh_tw_free_trial_cta_footer(inputs)
});